"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DocPdf_exports = {};
__export(DocPdf_exports, {
  default: () => DocPdf_default
});
module.exports = __toCommonJS(DocPdf_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00002 5.0999C7.22683 5.0999 6.60002 5.7267 6.60002 6.4999V9.4999C6.60002 9.83127 6.3314 10.0999 6.00002 10.0999C5.66865 10.0999 5.40002 9.83127 5.40002 9.4999V6.4999C5.40002 5.06396 6.56408 3.8999 8.00002 3.8999H14.6134C15.0114 3.8999 15.3952 4.04826 15.6897 4.316L18.0763 6.48564C18.4099 6.78888 18.6 7.21875 18.6 7.66955V9.4999C18.6 9.83127 18.3314 10.0999 18 10.0999C17.6687 10.0999 17.4 9.83127 17.4 9.4999V8.75H15C14.1716 8.75 13.5 8.07843 13.5 7.25V5.0999H8.00002ZM14.5 5.0999V7.25C14.5 7.52614 14.7239 7.75 15 7.75H17.4V7.66955C17.4 7.55685 17.3525 7.44938 17.2691 7.37357L14.8825 5.20393C14.8089 5.13699 14.7129 5.0999 14.6134 5.0999H14.5ZM4.86595 15.3682H3.55795V12.9322H4.86595C5.69395 12.9322 6.19795 13.4002 6.19795 14.1562C6.19795 14.8882 5.69395 15.3682 4.86595 15.3682ZM3.54595 16.7962H5.06995C6.74995 16.7962 7.86595 15.6922 7.86595 14.1442C7.86595 12.6082 6.74995 11.4922 5.06995 11.4922H1.88995V20.0002H3.54595V16.7962ZM11.6081 18.4642H10.2881V13.0282H11.6201C13.0121 13.0282 14.1641 13.9042 14.1641 15.7522C14.1641 17.6002 13.0001 18.4642 11.6081 18.4642ZM8.63214 20.0002H11.6681C14.0921 20.0002 15.8801 18.4402 15.8801 15.7522C15.8801 13.0642 14.1041 11.4922 11.6801 11.4922H8.63214V20.0002ZM18.4837 20.0002H16.8157V11.4922H22.1917V13.0642H18.4717V15.1642H21.7837V16.6882H18.4837V20.0002Z",
      fill: "currentColor"
    }
  )
);
const SvgDocPdf = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DocPdf_default = SvgDocPdf;
